/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';
import { ESidePanelContent } from '../../models';

export enum ESidePanelActions {
  OpenSidePanel = '[ESidePanel] Open Side Panel',
  CloseSidePanel = '[ESidePanel] Close Side Panel'
}

export class OpenSidePanel implements Action {
  public readonly type = ESidePanelActions.OpenSidePanel;

  constructor(public payload: ESidePanelContent) {}
}

export class CloseSidePanel implements Action {
  public readonly type = ESidePanelActions.CloseSidePanel;
}

export type SidePanelActions = OpenSidePanel | CloseSidePanel;
